<template>
  <div class="footer-box">
    <div class="container footer-box-container">
      <img
        :src="
          currentLocale === 'zh'
            ? require('@/assets/img/pc/footer-logo.png')
            : require('@/assets/img/pc/en-footer-logo.png')
        "
        class="footer-logo"
      />

      <div class="footer-info">
        <div class="footer-address">{{ $t('footer.address') }}</div>
        <div class="footer-copyright">{{ $t('footer.copyright') }}</div>
      </div>
      <div class="footer-qrcode">
        <img src="@/assets/img/pc/qr-code.png" class="footer-qrcode-img" />
        <div class="footer-qrcode-text-box">
          <div class="footer-qrcode-text">{{ $t('footer.qrcode') }}</div>

          <div class="footer-qrcode-text">
            {{ $t('footer.qrcodeText') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.footer-box {
  height: 150px;
  background: #222226;
  border-radius: 20px 20px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  .footer-box-container {
    display: flex;
    justify-content: center;
    // justify-content: space-between;
    align-items: center;
    .footer-info {
      //   flex: 1;
      color: #fff;
      font-size: 14px;
      line-height: 20px;
      margin-left: 40px;
      padding-left: 40px;
      border-left: 1px solid #3d3d40;
      .footer-address {
        font-weight: 400;
        font-size: 14px;
        color: #c6c8cc;
        line-height: 20px;
        margin-bottom: 10px;
        text-align: left;
      }
      .footer-copyright {
        font-weight: 400;
        font-size: 14px;
        color: #787b80;
        line-height: 20px;
        text-align: left;
      }
    }
    .footer-qrcode {
      display: flex;
      align-items: center;
      margin-left: 80px;
      .footer-qrcode-img {
        height: 72px;
        width: 72px;
        margin-right: 17px;
      }
      .footer-qrcode-text-box {
        text-align: left;
        font-weight: 400;
        font-size: 14px;
        color: #c6c8cc;
        line-height: 24px;
      }
    }
  }
  .footer-logo {
    width: 150px;
    height: 38px;
  }
}
</style>
